import type {FC} from "react";
import type React from "react";
import {useContext} from "react";

import {UserContext} from "../contexts/UserContext";
import WebSocketContext from "../contexts/WebSocketContext";
import {useWebSocket} from "../hooks/useWebSocket";

interface Props {
    url: string;
    children: React.ReactNode;
}

const WebSocketProvider: FC<Props> = ({url, children}) => {
    const {isAuthenticated} = useContext(UserContext);
    const websocket = useWebSocket(url, isAuthenticated);

    return <WebSocketContext.Provider value={websocket}>{children}</WebSocketContext.Provider>;
};

export default WebSocketProvider;
